import { Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import { ctpsMask } from 'utils/masks'

export default function CustomFormCTPSAnswer() {
  const { answer } = useCustomFormAnswer()

  if (!answer.answer) {
    return (
      <Text variant="secondary" fontStyle="italic">
        Sem resposta
      </Text>
    )
  }

  const [ctps] = answer.answer

  return <Text color="primary">{ctpsMask(ctps)}</Text>
}
